import {computed} from 'vue'
import {useMediaQuery} from '@vueuse/core'

// matches with tailwindcss default breakpoints
export const isSm = useMediaQuery('(min-width: 640px)')
export const isMd = useMediaQuery('(min-width: 768px)')
export const isLg = useMediaQuery('(min-width: 1024px)')
export const isXl = useMediaQuery('(min-width: 1280px)')
export const is2xl = useMediaQuery('(min-width: 1536px)')

export const isMobile = computed(() => !isLg.value)

const UA = window.navigator.userAgent.toLowerCase()
const isAndroid = UA.indexOf('android') > -1
const isFirefox = UA.indexOf('firefox') > -1
const isIOS = /iphone|ipad|ipod|ios/.test(UA) || (
  UA.indexOf('macintosh') !== -1 &&
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2
)

const isChrome = UA.indexOf('chrome') > -1

let isNativeMultiSelectOneRow = false
if (isChrome) {
  const select = document.createElement('select')
  select.multiple = true
  for (let i = 0; i < 10; i++) {
    const option = document.createElement('option')
    select.appendChild(option)
  }
  select.style.fontSize = '40px'
  select.style.lineHeight = '40px'
  select.style.border = 'none'
  select.style.padding = '0'
  select.style.margin = '0'
  select.style.appearance = 'none'
  select.style.position = 'fixed'
  select.style.opacity = '0'
  document.body.appendChild(select)
  isNativeMultiSelectOneRow = select.clientHeight < 80
  document.body.removeChild(select)
}

export const shouldUseNativeSelect = isAndroid || isIOS || isNativeMultiSelectOneRow
export const shouldUseNativeMultiSelect = isNativeMultiSelectOneRow || (shouldUseNativeSelect && !isFirefox)
